import { FmdCode } from "../../../dto/FMD/Models";


export default class Gs1Scanner {

    alternateBuffer: string = "";
    buffer: Array<[ string, number ]> = [];
    active: boolean;
    timer: any;

    FmdCode: FmdCode|null;

    constructor() {
        this.active = false;
    }

    AddKeyDown(key: string, keyCode:number): number{

        if (this.active) {
            // We are already looking for FMD code
            this.alternateBuffer = this.alternateBuffer + "," + keyCode

            //if (!(key.length == 1 || key =="Enter")) {
            //    console.log("Key " + key)
            //    return 0;
            //}

            
            //console.log(this.buffer)

            if (key == "Enter") {
                console.log("Decoding FMD " + this.alternateBuffer);
                var code = this.buffer;
                clearTimeout(this.timer);
                this.EndScanning();
                console.log("Decoding FMD " + code);
                

                var decoder = new Gs1FmdDecoder(code);
                this.FmdCode = decoder.Decode();
                
                return 1;
            }

            this.buffer.push([ key, keyCode ]);
            return 0;
        }
        else {
            // Is this a valid start
            if (key == "0") {
                console.log("Starting Scanner")
                this.buffer.push([key, keyCode ]);
                this.alternateBuffer = this.alternateBuffer + "," + key
                this.active = true;
                this.timer = setTimeout(this.EndScanning, 500)

                return 0;
            }
            else {
                //Ignore these keystrokes
                return -1;
            }
        }
    }

    EndScanning() {
        console.log("Ending Scanner")
        this.buffer = [];
        this.alternateBuffer = "";
        this.active = false;
    }
}


export class BarcodeScanner {

    alternateBuffer: string = "";
    buffer: string = "";
    active: boolean;
    timer: any;

    FmdCode: FmdCode | null;

    constructor() {
        this.active = false;
    }

    AddKeyDown(key: string, keyCode: string): number {

        if (this.active) {
            // We are already looking for FMD code
            this.alternateBuffer = this.alternateBuffer + "," + keyCode

            if (!(key.length == 1 || key == "Enter")) {
                console.log("Key " + key)
                return 0;
            }


            //console.log(this.buffer)

            if (key == "Enter") {
                alert("Decoding FMD " + this.alternateBuffer);
                var code = this.buffer;
                clearTimeout(this.timer);
                this.EndScanning();
                console.log("Decoding FMD " + code);


                var decoder = new FmdDecoder(code);
                this.FmdCode = decoder.Decode();

                return 1;
            }

            this.buffer = this.buffer + key;
            return 0;
        }
        else {
            // Is this a valid start
            if (key == "0") {
                this.buffer = this.buffer + key;
                this.alternateBuffer = this.alternateBuffer + "," + key
                this.active = true;
                this.timer = setTimeout(this.EndScanning, 500)

                return 0;
            }
            else {
                //Ignore these keystrokes
                return -1;
            }
        }
    }

    EndScanning() {
        this.buffer = "";
        this.alternateBuffer = "";
        this.active = false;
    }
}


class Gs1FmdDecoder {
    fmdCode: FmdCode;
    code: Array<[string, number]>;
    index: number = 0;
    seperatorArr = [119]

    constructor(buffer: Array<[string, number]>) {
        this.code = buffer.filter(k => k[0].toLowerCase() != "shift" && k[0] != "$" );
        console.log("Buffer ")
        console.log(this.code)
        this.fmdCode = new FmdCode();
        var configuredSeperator = localStorage.getItem("ScannerSeperator");

        if (configuredSeperator) {
            this.seperatorArr = JSON.parse(configuredSeperator);
        }

    }

    Decode(): FmdCode | null {
        this.fmdCode = new FmdCode();

        this.GetItem();
        this.GetItem();
        this.GetItem();
        this.GetItem();

        if (this.fmdCode.gtin || this.fmdCode.sn)//this.fmdCode.batchNumber && this.fmdCode.expiryDate && 
            return this.fmdCode;

        return null;
    }

    GetItem() {
        if (this.code.length == this.index)
            return;

        var header = this.code[this.index][0] + this.code[this.index + 1][0];

        this.index += 2;

        if (header == "01") {
            this.GetGtin();
            return;
        }

        if (header == "17") {
            this.GetExpiry();
            return;
        }

        if (header == "21") {
            this.GetSerial();
            return;
        }
        if (header == "10") {
            this.GetBatch();
            return;
        }
    }

    GetGtin() {
        this.fmdCode.gtin = ""
        for (var i = 0; i < 14; i++) {
            this.fmdCode.gtin = this.fmdCode.gtin + this.code[this.index + i][0];
        }

        this.index += 14;
    }
    GetExpiry() {
        this.fmdCode.expiryDate = ""
        for (var i = 0; i < 6; i++) {
            this.fmdCode.expiryDate = this.fmdCode.expiryDate + this.code[this.index + i][0];
        }
        //this.fmdCode.expiryDate = this.code.substring(this.index, this.index + 6);
        this.index += 6;
    }
    GetSerial() {
        let curr: string;
        var nextHeader: string;
        var terminatorFound: boolean = false;
        var endOfCode: boolean = false;
        this.fmdCode.sn = "";

        while (!terminatorFound && !endOfCode) {

            this.fmdCode.sn = this.fmdCode.sn + this.code[this.index][0];

            this.index++;

            endOfCode = this.code.length == this.index;
            if (!endOfCode) {
                terminatorFound = this.TerminatorFound(this.index)
            }

        }

        //if (terminatorFound) this.index++;
        if (terminatorFound) this.index += this.seperatorArr.length;
        return;
    }
    GetBatch() {
        let curr: string;
        var nextHeader: string = "";
        var validNextHeaderFound: boolean = false;

        var terminatorFound: boolean = false;
        var endOfCode: boolean = false;
        this.fmdCode.batchNumber = "";
        while (!validNextHeaderFound && !endOfCode && !terminatorFound) {

            this.fmdCode.batchNumber = this.fmdCode.batchNumber + this.code[this.index][0];

            this.index++;

            endOfCode = this.code.length == this.index;
            if (!endOfCode) {
                //terminatorFound = (this.code[this.index])[1] == 119;
                terminatorFound = this.TerminatorFound(this.index)

                if (!terminatorFound) {
                    if (this.index < this.code.length - 1) {
                        nextHeader = this.code[this.index][0] + this.code[this.index + 1][0];
                    }
                    //validNextHeaderFound =
                    //    (nextHeader == "01" && !this.fmdCode.gtin) ||
                    //    (nextHeader == "10" && !this.fmdCode.batchNumber) ||
                    //    (nextHeader == "17" && !this.fmdCode.expiryDate) ||
                    //    (nextHeader == "21" && !this.fmdCode.sn);
                }
            }
        }
        if (terminatorFound) this.index += this.seperatorArr.length;

        return;
    }

    TerminatorFound(index: number): boolean
    {
        if (!this.seperatorArr) {
            return false;
        }

        if (this.code.length < index + this.seperatorArr.length) {
            return false;
        }

        for (var i = 0; i < this.seperatorArr.length; i++) {
            if (this.code[index + i][1] != this.seperatorArr[i])
                return false;
        }

        return true;
    }
}


class FmdDecoder {
    fmdCode: FmdCode;
    code: string;
    index: number = 0;

    constructor(code: string) {
        this.code = code;
        this.fmdCode = new FmdCode();
    }

    Decode(): FmdCode | null{
        this.fmdCode = new FmdCode();
        
        this.GetItem();
        this.GetItem();
        this.GetItem();
        this.GetItem();

        if (this.fmdCode.batchNumber && this.fmdCode.expiryDate && this.fmdCode.gtin && this.fmdCode.sn) 
            return this.fmdCode;

        return null;
    }

    GetItem() {
        var header = this.code.substring(this.index, this.index+2);
        this.index += 2;
        if (header == "01") {
            this.GetGtin();
            return;
        }

        if (header == "17") {
            this.GetExpiry();
            return;
        }

        if (header == "21") {
            this.GetSerial();
            return;
        }
        if (header == "10") {
            this.GetBatch();
            return;
        }
    }

    GetGtin() {
        this.fmdCode.gtin = this.code.substring(this.index, this.index+14);
        this.index += 14;
    }
    GetExpiry() {
        this.fmdCode.expiryDate = this.code.substring(this.index, this.index+6);
        this.index += 6;
    }
    GetSerial() {
        let curr: string;
        var nextHeader: string;
        var validNextHeaderFound: boolean = false;
        var endOfCode: boolean = false;
        this.fmdCode.sn = "";
        while (!validNextHeaderFound && !endOfCode) {

            this.fmdCode.sn = this.fmdCode.sn + this.code[this.index];

            this.index++;

            nextHeader = this.code.substring(this.index, this.index+2);
            validNextHeaderFound =
                (nextHeader == "01" && !this.fmdCode.gtin) ||
                (nextHeader == "10" && !this.fmdCode.batchNumber) ||
                (nextHeader == "17" && !this.fmdCode.expiryDate) ||
                (nextHeader == "21" && !this.fmdCode.sn);

            endOfCode = this.code.length == this.index;

        }

        return;
    }
    GetBatch() {
        let curr: string;
        var nextHeader: string;
        var validNextHeaderFound: boolean = false;
        var endOfCode: boolean = false;
        this.fmdCode.batchNumber = "";
        while (!validNextHeaderFound && !endOfCode) {

            this.fmdCode.batchNumber = this.fmdCode.batchNumber + this.code[this.index];

            this.index++;

            nextHeader = this.code.substring(this.index, this.index+2);
            validNextHeaderFound =
                (nextHeader == "01" && !this.fmdCode.gtin) ||
                (nextHeader == "10" && !this.fmdCode.batchNumber) ||
                (nextHeader == "17" && !this.fmdCode.expiryDate) ||
                (nextHeader == "21" && !this.fmdCode.sn);

            endOfCode = this.code.length == this.index ;
        }

        return;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/FmdControls/BagManagement/Scanner.ts